import { queryOptions, useQuery } from '@tanstack/react-query';

import { SecurityInsightsResourceDetailsRequest } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

type UseResourceDetailsQueryArgs = {
  id: string;
  standard?: SecurityInsightsResourceDetailsRequest['standard'];
  enabled?: boolean;
};

const SECURITY_RESOURCE_DETAILS_QUERY_KEY = 'security-resource-details';

const getResourceDetailsQueryKey = ({
  id,
  standard,
}: Pick<UseResourceDetailsQueryArgs, 'id' | 'standard'>) =>
  [SECURITY_RESOURCE_DETAILS_QUERY_KEY, id, standard] as const;

const getResourceDetailsQueryOptions = ({
  id,
  standard = 'cast',
  enabled = true,
}: UseResourceDetailsQueryArgs) =>
  queryOptions({
    queryKey: getResourceDetailsQueryKey({ id, standard }),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getResourceDetails({
        id,
        standard,
      });
      return data;
    },
    enabled,
  });

export const useResourceDetailsQuery = (
  params: UseResourceDetailsQueryArgs
) => {
  const {
    isLoading,
    data: resourceDetails,
    error,
    refetch,
  } = useQuery(getResourceDetailsQueryOptions(params));

  return {
    isLoading,
    resourceDetails,
    error,
    refetch,
  };
};
